import { Component, OnInit } from '@angular/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { Navigator } from '../../menu/navigator';

@Component({
  selector: 'app-site-logo',
  templateUrl: './site-logo.component.html',
  styleUrls: ['./site-logo.component.scss'],
})

export class SiteLogoComponent implements OnInit {

  public environmentName: string;
  public isSubBrandAvailable: boolean = false;
  public subBrandLogo: string;
  iGamingUrl: any;

  constructor(
    public config: ConfigService,
    public keywordService: KeywordsService,
    public lobbyNavigation: LobbyNavigator,
    public navigator: Navigator,
    public eventsService: EventsService,
    private appLinksService:AppLinksService
  ) { }

  ngOnInit(): void {

    this.iGamingUrl = this.config.getConfig().FEATURE_IGAMING_URL ?? 'https://igamingontario.ca/en';
    this.getSiteLogoLoadData();

    this.eventsService.subscribe("event:config:reload", () => {
        this.getSiteLogoLoadData();
    });
  }

  private getSiteLogoLoadData(): void {
    this.config.isLoaded().then(() => {
      this.environmentName = this.config.getState().toLowerCase();
      this.subBrandLogo = this.config.getConfig()["FEATURE_BRAND_LOGO"];
      this.isSubBrandAvailable = this.checkSubBrand(this.subBrandLogo);
    });
  }

  private checkSubBrand(url: string): boolean {
    const imageExtensions = ['.svg', '.jpg', '.png', '.jpeg', '.gif'];
    const extension = url?.substring(url?.lastIndexOf('.'))?.toLowerCase();

    return imageExtensions.includes(extension);
  }

  protected onLogoClick() {
    return this.lobbyNavigation.toKeyTab('home');
  }
  onLogoClickSubBrand(){
    this.appLinksService.openExternalPage(this.iGamingUrl)
  }


}
